/**
 * This is a thing which you can attach to something which uses a callback for
 * later use as a promise. In general where you can do just
 * `new Promise(resolve => {...})` you should do that instead.
 */
class PromiseProxy {
    constructor() {
        this.reject = (...args) => console.error(
            "Promise proxy rejected before the promise was used!"
        )
        this.resolve = (...args) => console.error(
            "Promise proxy resolved before the promise was used!"
        )
    }
    /**
     * @param {() => *} f
     */
    promise(f) {
        return new Promise(
            (resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
                f()
            }
        )
    }
}